import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { Features } from "../components/features";
import { useSEO } from "../hooks/useSEO";

export const WhyUsPage = ({ data }) => {
  useSEO({
    title: "Why Choose Transwave Shipping | Licensed Freight Forwarder Dubai",
    description:
      "Discover why businesses trust Transwave Shipping and Logistics LLC in Dubai — UAE-licensed, multi-modal freight, end-to-end forwarding, and professional cargo handling across UAE and global routes.",
    canonical: "https://www.transwaveshipping.com/why-us",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero */}
      <div className="page-hero page-hero--whyus">
        <div className="container">
          <motion.div
            className="page-hero-bottom-left"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Why Choose Transwave</h1>
            <p>Trusted by businesses across the UAE for reliable, compliant, and efficient logistics</p>
            <nav className="page-breadcrumb" aria-label="breadcrumb">
              <Link to="/">Home</Link> <span>/</span> <span>Why Choose Us</span>
            </nav>
          </motion.div>
        </div>
      </div>

      <Features data={data.Features} />

      {/* Stats Row */}
      <div className="why-us-stats">
        <div className="container">
          <div className="row">
            {[
              { num: "UAE", label: "Licensed & Regulated" },
              { num: "3+", label: "Transport Modes Covered" },
              { num: "24h", label: "Quote Turnaround" },
              { num: "100%", label: "Documentation Accuracy" },
            ].map((stat, i) => (
              <motion.div
                key={i}
                className="col-md-3 col-sm-6 stat-item text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                <div className="stat-number">{stat.num}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="page-cta">
        <div className="container text-center">
          <h3>See the difference for yourself</h3>
          <p>Get in touch today and let our team handle your next shipment.</p>
          <Link to="/contact" className="btn btn-custom btn-lg">Contact Us</Link>
        </div>
      </div>
    </Layout>
  );
};
